export const GET_ALL_DEDICATED_INVOICE = 'GET_ALL_DEDICATED_INVOICE';
